const APPLE_STORE_LINK = 'https://apps.apple.com/us/app/id1052845425';
const GOOGLE_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.sunrun.mysunrun';

const CUSTOMER_APP_APPLE_STORE_LINK = 'https://apps.apple.com/us/app/sunrun/id6443806453';
const CUSTOMER_APP_GOOGLE_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.sunrun.customerapp';

export { APPLE_STORE_LINK, GOOGLE_STORE_LINK, CUSTOMER_APP_APPLE_STORE_LINK, CUSTOMER_APP_GOOGLE_STORE_LINK };
